import {
  Box,
  Columns,
  ColumnsItem,
  Container,
  Modal,
  RowItem,
  Rows,
  Text,
  TextLevels,
  Title,
  TitleLevels,
} from '@bytel/trilogy-react-ts';
import { useTranslation } from 'react-i18next';
import { PopupTelephonesAchetesProps } from './type';

const PopupTelephonesAchetes = ({ data, onClose }: PopupTelephonesAchetesProps) => {
  const { t } = useTranslation('domain/home', {
    keyPrefix: 'consommationTelephone',
  });
  return (
    <Modal data-cy="popup-telephones" active closeIcon onClose={onClose}>
      <Container className="is-marginless" fluid>
        <Rows>
          <RowItem>
            <Title data-cy="popup-telephones-title" level={TitleLevels.ONE}>
              {data?.total} {data?.type} {t('popupTitle')}
            </Title>
          </RowItem>
          <Columns multiline>
            {data?.list.map((item) => (
              <ColumnsItem size={4} key={item.label}>
                <Box className="has-text-centered">
                  <Text level={TextLevels.TWO}>{item.label}</Text>
                  <Title level={TitleLevels.THREE}>{item.count}</Title>
                </Box>
              </ColumnsItem>
            ))}
          </Columns>
        </Rows>
      </Container>
    </Modal>
  );
};
export default PopupTelephonesAchetes;
